import { Star, Sparkles, CheckCircle, AlertCircle } from "lucide-react";

export default function OverviewReviewCard({
  name,
  date,
  rating,
  review,
  suggestedResponse,
  status,
}) {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="font-semibold text-slate-900">{name}</h3>

          <p className="text-sm text-slate-500 mt-1">{date}</p>
        </div>

        <StatusBadge status={status} />
      </div>

      <div className="flex items-center gap-1 mt-4">
        {Array.from({ length: 5 }).map((_, index) => (
          <Star
            key={index}
            size={16}
            className={
              index < rating
                ? "fill-yellow-400 text-yellow-400"
                : "text-slate-300"
            }
          />
        ))}
      </div>

      <p className="mt-4 text-sm leading-6 text-slate-700">{review}</p>

      {suggestedResponse && (
        <div className="mt-5 rounded-xl border border-indigo-100 bg-indigo-50 p-4">
          <div className="flex items-center gap-2 text-indigo-700 font-semibold text-sm">
            <Sparkles size={16} />
            Suggested Response
          </div>

          <p className="mt-2 text-sm leading-6 text-indigo-900">
            {suggestedResponse}
          </p>
        </div>
      )}
    </div>
  );
}

function StatusBadge({ status }) {
  const variants = {
    posted: {
      label: "Posted",
      className: "bg-green-50 text-green-700 border-green-200",
      icon: <CheckCircle size={14} />,
    },

    needs_response: {
      label: "Needs Response",
      className: "bg-orange-50 text-orange-700 border-orange-200",
      icon: <AlertCircle size={14} />,
    },

    approved: {
      label: "Approved",
      className: "bg-blue-50 text-blue-700 border-blue-200",
      icon: <CheckCircle size={14} />,
    },
  };

  const current = variants[status] || variants.needs_response;

  return (
    <div
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border text-xs font-medium ${current.className}`}
    >
      {current.icon}
      {current.label}
    </div>
  );
}
